// import Container from 'react-bootstrap/Container';
// import Navbar from 'react-bootstrap/Navbar';
import React, {useState, useEffect} from "react";
import DateTime from "../Body/DateTime/DateTime";
import cklogo from "../../images/cklogo.jpg";
import "./Header.css";
import {BsPower} from "react-icons/bs";
import {useNavigate} from "react-router-dom";
// import { BsSearch } from 'react-icons/fa';
import {Button, Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import axios from "../util/Axios/AxiosInstance";
import Skeleton from "react-loading-skeleton";

function Header() {
    // var [date, setDate] = useState(new Date());
    var [username, setUsername] = useState("");
    const [branchList, setBranchList] = useState([{id: "", branchId: "", branchName:  "", genderSpecific: ""},]);
    const [branch, setBranch] = useState(localStorage.getItem("branch"));
    const [branchId, setBranchId] = useState(localStorage.getItem("branchId"));
    const [genderSpecific, setGenderSpecific] = useState(localStorage.getItem("genderSpecific"));
    const [loading,setLoading] = useState(false);


    const onSelectBranch = (e) => {
        setBranchId(e.target.value);
        let genderSpecific1 = branchList.filter(item => item.branchId.includes(e.target.value));
        // console.log(genderSpecific1);
        setGenderSpecific(genderSpecific1[0].genderSpecific);
        setBranch(e.target.selectedOptions[0].id);
        localStorage.setItem("plantCode", e.target.value);
        window.location.reload();
    };

    useEffect(() => {
        // var timer = setInterval(() => setDate(new Date()), 1000)
        // return function cleanup() {
        //   clearInterval(timer);
        // }
    });
    useEffect(() => {
        localStorage.setItem("branch", branch);
        localStorage.setItem("branchId", branchId);
        localStorage.setItem("plantCode", branchId);
        localStorage.setItem("genderSpecific", genderSpecific);
    }, [branch])

    useEffect(() => {
        const username = localStorage.getItem("username");
        getBranchDetails();
        setUsername(username);
    }, []);

    const getBranchDetails = async () => {
        try {
            setLoading(false);
            const data = await axios.get("getBranchDetails");
            setBranchList(data.data);
            setLoading(true);
            // console.log(data.data);
            // console.log(branchList);
        } catch (e) {

        }
    };
    let navigate = useNavigate();
    const goToLoginPg = () => {
        let path = `/`;
        navigate(path);
    };

    return (
        <div className="header-shell outlineBoxShadow">
            <div className="reg-headTabsBg">
                <div className="header-logo-wrap">
                    <img src={cklogo} className="reg-samplebox-logo" alt="CavinKare"/>
                </div>
                <div className="header-actions">
                    {localStorage.getItem("role") === "SuperAdmin" && loading === true && (
                        <div className="branchDivSelect">
                            <Form.Select
                                className="branchSelect"
                                onChange={(e) => onSelectBranch(e)}
                                value={branchId}
                            >
                                {branchList.map((branchItem) => (
                                    <option
                                        key={branchItem.branchId}
                                        value={branchItem.branchId}
                                        id={branchItem.branchName}
                                    >
                                        {loading === true ? branchItem.branchId : <Skeleton/>}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    )}
                    <div className="header-user-info">
                        <p className="header-signed-in">
                            Signed in as: <a href="#login">{username}</a>
                        </p>
                        <div className="dateTimeDiv">
                            <DateTime/>
                        </div>
                    </div>
                    <OverlayTrigger
                        key="bottom"
                        placement="bottom"
                        overlay={
                            <Tooltip id="tooltip-bottom" className="tooltipClass">
                                Logout
                            </Tooltip>
                        }
                    >
                        <Button variant="link" className="header-logout-btn" onClick={goToLoginPg}>
                            <BsPower className="logoutBtn"/>
                        </Button>
                    </OverlayTrigger>
                </div>
            </div>
            <div className="blueLine"/>
        </div>
    );
}

export default Header;
